var a = /* @__PURE__ */ ((s) => (s.PlanetIdAsc = "PlanetIDAsc", s.PlanetIdDesc = "PlanetIDDesc", s.PriceAsc = "PriceAsc", s.PriceDesc = "PriceDesc", s.ListAtDesc = "ListingTimeDesc", s.UpdateAtDesc = "UpdateAtDesc", s.PlanetTypeAsc = "PlanetTypeAsc", s.PlanetTypeDesc = "PlanetTypeDesc", s))(a || {}), e = /* @__PURE__ */ ((s) => (s.Planet = "Reveal", s.Core = "Core", s))(e || {}), i = /* @__PURE__ */ ((s) => (s[s.TRADE = 0] = "TRADE", s[s.INVENTORY = 1] = "INVENTORY", s[s.SEED_INVENTORY = 2] = "SEED_INVENTORY", s[s.OTHERS_INVENTORY = 3] = "OTHERS_INVENTORY", s[s.FAVORITE = 4] = "FAVORITE", s))(i || {}), c = /* @__PURE__ */ ((s) => (s.Enable = "Enable", s.Staked = "Staked", s.StakedToStar = "StakedToStar", s.Disable = "Disable", s))(c || {}), t = /* @__PURE__ */ ((s) => (s.Inferno = "Inferno", s.Gigas = "Gigas", s.Leviathan = "Leviathan", s.Tempest = "Tempest", s.Archipelago = "Archipelago", s.Volcanic = "Volcanic", s.Karsts = "Karsts", s.Tundra = "Tundra", s.Delta = "Delta", s.Dunes = "Dunes", s.Mountainous = "Mountainous", s.Foresty = "Foresty", s.Wasteland = "Wasteland", s.Oasis = "Oasis", s.Normal = "Normal", s))(t || {}), r = /* @__PURE__ */ ((s) => (s.Active = "active_skills", s.Passive = "passive_skills", s.PlanetPassive = "planet_passive_skills", s.PlanetEnergize = "planet_energized_skills", s.Binded = "binded", s.AutoAttack = "auto_attack", s))(r || {}), d = /* @__PURE__ */ ((s) => (s[s.Active = 0] = "Active", s[s.Passive = 1] = "Passive", s[s.Binded = 2] = "Binded", s))(d || {}), _ = /* @__PURE__ */ ((s) => (s[s.All = -1] = "All", s[s.Fury = 0] = "Fury", s[s.Wisdom = 1] = "Wisdom", s[s.Fate = 2] = "Fate", s))(_ || {}), n = /* @__PURE__ */ ((s) => (s.Fire = "fire", s.Water = "water", s.Air = "air", s.Earth = "earth", s.None = "none", s))(n || {}), v = /* @__PURE__ */ ((s) => (s[s.Normal = -1] = "Normal", s[s.Primal = 0] = "Primal", s[s.Divine = 1] = "Divine", s[s.Arcane = 2] = "Arcane", s[s.Mythic = 3] = "Mythic", s[s.Elemental = 4] = "Elemental", s[s.None = 999] = "None", s))(v || {});
const u = {
  [
    -1
    /* Normal */
  ]: "normal",
  0: "primal",
  1: "divine",
  2: "arcane",
  3: "mythic",
  4: "elemental",
  999: "none"
};
var A = /* @__PURE__ */ ((s) => (s[s.None = -1] = "None", s[s.Conjunction = 0] = "Conjunction", s[s.Age = 1] = "Age", s[s.Seed = 2] = "Seed", s))(A || {});
const D = [
  {
    id: 0,
    nameId: "list.sort_price_asc",
    value: "PriceAsc"
    /* PriceAsc */
  },
  {
    id: 1,
    nameId: "list.sort_price_desc",
    value: "PriceDesc"
    /* PriceDesc */
  },
  {
    id: 2,
    nameId: "list.sort_id_asc",
    value: "PlanetIDAsc"
    /* PlanetIdAsc */
  },
  {
    id: 3,
    nameId: "list.sort_id_desc",
    value: "PlanetIDDesc"
    /* PlanetIdDesc */
  },
  {
    id: 4,
    nameId: "list.sort_updated_at_desc",
    value: "UpdateAtDesc"
    /* UpdateAtDesc */
  },
  {
    id: 5,
    nameId: "list.sort_planet_type_asc",
    value: "PlanetTypeAsc"
    /* PlanetTypeAsc */
  },
  {
    id: 6,
    nameId: "list.sort_planet_type_desc",
    value: "PlanetTypeDesc"
    /* PlanetTypeDesc */
  }
], m = [
  {
    id: 0,
    nameId: "list.sort_price_asc",
    value: "PriceAsc"
    /* PriceAsc */
  },
  {
    id: 1,
    nameId: "list.sort_price_desc",
    value: "PriceDesc"
    /* PriceDesc */
  },
  {
    id: 2,
    nameId: "list.sort_id_asc",
    value: "PlanetIDAsc"
    /* PlanetIdAsc */
  },
  {
    id: 3,
    nameId: "list.sort_id_desc",
    value: "PlanetIDDesc"
    /* PlanetIdDesc */
  },
  {
    id: 4,
    nameId: "list.sort_list_at_desc",
    value: "ListingTimeDesc"
    /* ListAtDesc */
  },
  {
    id: 5,
    nameId: "list.sort_planet_type_asc",
    value: "PlanetTypeAsc"
    /* PlanetTypeAsc */
  },
  {
    id: 6,
    nameId: "list.sort_planet_type_desc",
    value: "PlanetTypeDesc"
    /* PlanetTypeDesc */
  }
], I = [
  {
    id: 0,
    nameId: "list.sort_id_asc",
    value: "PlanetIDAsc"
    /* PlanetIdAsc */
  },
  {
    id: 1,
    nameId: "list.sort_id_desc",
    value: "PlanetIDDesc"
    /* PlanetIdDesc */
  },
  {
    id: 2,
    nameId: "list.sort_updated_at_desc",
    value: "UpdateAtDesc"
    /* UpdateAtDesc */
  },
  {
    id: 3,
    nameId: "list.sort_planet_type_asc",
    value: "PlanetTypeAsc"
    /* PlanetTypeAsc */
  },
  {
    id: 4,
    nameId: "list.sort_planet_type_desc",
    value: "PlanetTypeDesc"
    /* PlanetTypeDesc */
  }
], o = 20, E = 2, l = 20;
export {
  o as AGE_PASSED_PER_DAY,
  v as CoreType,
  n as ElementType,
  l as MAX_PLANET_NAME,
  E as PLANET_YEAR_DECIMAL,
  A as PlanetCardInfoType,
  _ as PlanetClassType,
  u as PlanetCoreType,
  m as PlanetEmporiumSortItems,
  i as PlanetListMode,
  D as PlanetNormalSortItems,
  I as PlanetSelectSortItems,
  r as PlanetSkillType,
  a as PlanetSortBy,
  e as PlanetStage,
  c as PlanetStatus,
  t as PlanetType,
  d as SkillFilterMode
};
//# sourceMappingURL=planet.js.map
